export function SonnyMark(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 128"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_273_888)">
        <path
          d="M31.3249 31.2637H0V56.6652H31.3249V31.2637Z"
          fill="currentColor"
        />
        <path
          d="M116.658 77.1816H85.3333V102.583H116.658V77.1816Z"
          fill="currentColor"
        />
        <path
          d="M85.3334 52.7568H30.2448V77.1814H85.3334V52.7568Z"
          fill="currentColor"
        />
        <path
          d="M85.3333 102.583H0V127.008H85.3333V102.583Z"
          fill="currentColor"
        />
        <path d="M116.658 0H31.3249V31.2635H116.658V0Z" fill="currentColor" />
        <path
          d="M172.827 31.752H138.262V96.2481H172.827V31.752Z"
          fill="currentColor"
        />
        <path
          d="M172.827 1.52588e-05V31.752L256 31.752V1.52588e-05L172.827 1.52588e-05Z"
          fill="currentColor"
        />
        <path
          d="M172.827 96.2481V128H256V96.2481H172.827Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_273_888">
          <rect width="256" height="128" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function getMarkSVG(color: string) {
  return `<svg width="256" height="128" viewBox="0 0 256 128" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_273_888)">
      <path d="M31.3249 31.2637H0V56.6652H31.3249V31.2637Z" fill="${color}"/>
      <path d="M116.658 77.1816H85.3333V102.583H116.658V77.1816Z" fill="${color}"/>
      <path d="M85.3334 52.7568H30.2448V77.1814H85.3334V52.7568Z" fill="${color}"/>
      <path d="M85.3333 102.583H0V127.008H85.3333V102.583Z" fill="${color}"/>
      <path d="M116.658 0H31.3249V31.2635H116.658V0Z" fill="${color}"/>
      <path d="M172.827 31.752H138.262V96.2481H172.827V31.752Z" fill="${color}"/>
      <path d="M172.827 1.52588e-05V31.752L256 31.752V1.52588e-05L172.827 1.52588e-05Z" fill="${color}"/>
      <path d="M172.827 96.2481V128H256V96.2481H172.827Z" fill="${color}"/>
    </g>
    <defs>
      <clipPath id="clip0_273_888">
        <rect width="256" height="128" fill="white"/>
      </clipPath>
    </defs>
  </svg>`;
}
